import { css } from 'styled-components';
import { SIZES } from '../sizes/sizes';
import { EORA_EFFECTS } from '../effects/eoraEffects';

export type BlurSizes = typeof SIZES.SMALL | typeof SIZES.MEDIUM | typeof SIZES.LARGE | typeof SIZES.X_LARGE;

export type IBlurs = Record<BlurSizes, ReturnType<typeof css>>;
export interface IBlurProps {
  blur?: boolean | BlurSizes;
}

export const blurs: IBlurs = {
  [SIZES.SMALL]: css`
    backdrop-filter: ${EORA_EFFECTS.EFFECTS.STYLE.BACKGROUND_BLUR.SM};
  `,
  [SIZES.MEDIUM]: css`
    backdrop-filter: ${EORA_EFFECTS.EFFECTS.STYLE.BACKGROUND_BLUR.MD};
  `,
  [SIZES.LARGE]: css`
    backdrop-filter: ${EORA_EFFECTS.EFFECTS.STYLE.BACKGROUND_BLUR.LG};
  `,
  [SIZES.X_LARGE]: css`
    backdrop-filter: ${EORA_EFFECTS.EFFECTS.STYLE.BACKGROUND_BLUR.XL};
  `
};

const DEFAULT_BLUR = SIZES.SMALL;

export const useBlurCss = css<IBlurProps>`
  ${({ blur = false, theme }) => blur && theme.blurs[blur === true ? DEFAULT_BLUR : blur]};

  ${({ blur = false }) =>
    blur === false &&
    css`
      backdrop-filter: none;
    `};
`;
